import { DialogActions as MuiDialogActions } from '@material-ui/core';
import React, { ReactNode } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Button, ButtonProps } from '@shared/components/button-new';

import { styles } from './OverlayFooter.styles';
import { useOverlay, UseOverlayResult } from '../../Overlay.context';

export interface OverlayFooterButtonProps extends PropsWithOptionalClasses<Omit<ButtonProps, 'onClick'>> {
  onClick: (event: React.MouseEvent<HTMLButtonElement>, context: UseOverlayResult) => void;
}
/**
 * @deprecated Use OverlayFooterButtonProps instead
 */
export type ModalFooterButtonProps = OverlayFooterButtonProps;

export interface OverlayFooterProps extends WithStyles<typeof styles> {
  buttonsLeft?: OverlayFooterButtonProps[];
  buttonsRight?: OverlayFooterButtonProps[];
  contentLeft?: ReactNode;
  contentRight?: ReactNode;
  error?: ReactNode;
}
/**
 * @deprecated Use OverlayFooterProps instead
 */
export type ModalFooterProps = OverlayFooterProps;

const OverlayFooterComponent: React.FC<OverlayFooterProps> = ({
  buttonsLeft,
  buttonsRight,
  classes,
  contentLeft,
  contentRight,
  error,
}) => {
  const overlayContext = useOverlay();

  return (
    <MuiDialogActions classes={{ root: classes.root }}>
      {error && <span className={classes.error}>{error}</span>}
      <div className={classes.actions}>
        <div className={classes.actionsLeft}>
          {contentLeft}
          {buttonsLeft?.map((actionProps, index) => (
            <Button
              {...actionProps}
              key={index}
              onClick={actionProps.onClick ? (event) => actionProps.onClick?.(event, overlayContext) : undefined}
            />
          ))}
        </div>
        <div className={classes.actionsRight}>
          {contentRight}
          {buttonsRight?.map((actionProps, index) => (
            <Button
              {...actionProps}
              key={index}
              onClick={actionProps.onClick ? (event) => actionProps.onClick?.(event, overlayContext) : undefined}
            />
          ))}
        </div>
      </div>
    </MuiDialogActions>
  );
};

export const OverlayFooter = withStyles(styles)(OverlayFooterComponent);
/**
 * @deprecated Use OverlayFooter instead
 */
export const ModalFooter = OverlayFooter;
